import { BaseService } from "@ucchub/ui/src/BaseService";
import environment from "environment";
import { useEffect, useState } from "react";
import { OrganisationResponseV1 } from "@ucchub/ui/src/apiTypes/organisation";

export interface ICurrentUser {
  currentUser: {
    displayName: string;
    initials: string;
    email: string;
    userType: "customer" | "vodafone";
    role: string;
    orgId: string;
    userId: string;
  } | null;
  getCurrentUser: () => Promise<void>;
  getCurrentOrganisation: () => Promise<void>;
  isLoading: boolean;
  isCurrentOrganisationLoading: boolean;
  error: string | null;
  vFAdmin: boolean;
  isOrganisationStatus: boolean;
}

const useCurrentUser = () => {
  // Local state for the state hook
  const [currentUser, setCurrentUser] =
    useState<ICurrentUser["currentUser"]>(null);
  const [isLoading, setIsLoading] = useState<ICurrentUser["isLoading"]>(false);
  const [isCurrentOrganisationLoading, setIsCurrentOrganisationLoading] =
    useState<ICurrentUser["isCurrentOrganisationLoading"]>(false);
  const [error, setError] = useState<ICurrentUser["error"]>(null);
  const [vFAdmin, setVFAdmin] = useState<boolean>(false);
  const [isOrganisationStatus, setOrganisationStatus] =
    useState<boolean>(false);

  const getCurrentOrganisation = async (orgId: string) => {
    setIsCurrentOrganisationLoading(true);

    await BaseService.get<OrganisationResponseV1>(
      `${environment.api.organisation}/${orgId}`
    )
      .then(({ data }) => {
        const { status } = data;
        setOrganisationStatus(status === "Active" ? true : false);
      })
      .catch(({ response }) =>
        setError(`Error ${response.status}: ${response.data.message}`)
      )
      .finally(() => setIsCurrentOrganisationLoading(false));
  };

  // Fetch the permissions & update the state
  const getCurrentUser = async () => {
    setIsLoading(true);
    await BaseService.get(`${environment.api.roles}/nav-bar`)
      .then(({ data: { data } }) => {
        const currentUserData = data.secondaryNav.user.data;
        const userId = data.secondaryNav.user.id;
        // getCurrentOrganisation(data?.orgId);
        setCurrentUser({
          displayName: currentUserData.name,
          initials: currentUserData.initials,
          email: currentUserData.email,
          userType: data?.userType,
          role: currentUserData.role,
          orgId: data?.orgId,
          userId: userId,
        });
        data?.userType === "vodafone" && setVFAdmin(true);
      })
      .catch(({ response }) =>
        setError(`Error ${response.status}: ${response.data.message}`)
      )
      .finally(() => setIsLoading(false));
  };

  // Load the permissions once on load
  useEffect(() => {
    getCurrentUser();
  }, []);

  // Return all the available hook functions / values
  return {
    currentUser,
    getCurrentUser,
    getCurrentOrganisation,
    isLoading,
    isCurrentOrganisationLoading,
    error,
    vFAdmin,
    isOrganisationStatus,
  };
};

export default useCurrentUser;
